import { useQuery, type UseQueryResult } from '@tanstack/react-query';

type AccountBalanceType = {
    availableBalance: number;
    currentBalance: number;
}

const useAccountBalance = (): UseQueryResult<AccountBalanceType> => {
    const endpoint = '/api/Indue/accounts/current/balance';

    const accountBalanceQuery = useQuery({
        queryKey: ['accountBalance'],
        queryFn: async() => {
            const response = await fetch(endpoint);
            if (!response.ok) {
                throw new Error('Could not retrieve account balance');
            }

            const responseData = await response.json();
            if (!responseData) {
                throw new Error('Could not retrieve account balance');
            }

            return responseData;
        },
    });

    return accountBalanceQuery;
};

export default useAccountBalance;
